<div class="full-popup-head">
  <div class="full-popup-title flex"><em class="modal-title-icon icon-store"></em>{{ data.title }}</div>
  <button
    type="button"
    class="btn btn-header-button"
    data-id="btnCancelStoreRequest"
    *ngIf="hasCancelPermission()"
    (click)="cancelStoreRequest()"
  >
    <em class="icon-forbidden"></em>Cancel Request
  </button>
  <button
    type="button"
    class="btn btn-header-button"
    data-id="btnDeleteStoreRequest"
    *ngIf="hasDeletePermission()"
    (click)="deleteStoreRequest()"
  >
    <em class="icon-delete"></em>Delete
  </button>
  <button
    type="button"
    class="btn btn-header-button"
    *ngIf="status !== 'D' && hasViewHistoryPermission(status)"
    (click)="showHistory()"
  >
    <em class="icon-history"></em>History
  </button>
  <div class="full-popup-close">
    <a aria-label="Close" class="close" data-id="btnCloseModal" (click)="onCancel()">
      <em class="icon-close"></em>
    </a>
  </div>
  <div class="clearfix"></div>
</div>

<div class="admin-form">
  <div class="info-header-container">
    <div class="info-header-item" *ngIf="(storeView$ | async)?.requestNo">
      <div class="info-header-label">
        <span>Request No.:</span>
      </div>
      <div class="info-header-value">
        <span>{{ (storeView$ | async)?.requestNo }}</span>
      </div>
    </div>
    <div class="info-header-item">
      <div class="info-header-label">
        <span>Request Status:</span>
      </div>
      <div class="info-header-value">
        <span
          *ngIf="storePageMode.REQUEST_CREATE === data.mode; else getStatus"
          [ngClass]="getColorStatus('D')"
          class="request-status"
        >
          {{ 'STORE_REQUEST.STATUS.D' | translate }}</span
        >
        <ng-template #getStatus>
          <span [ngClass]="getColorStatus((storeView$ | async)?.status)" class="request-status">
            {{ 'STORE_REQUEST.STATUS.' + (storeView$ | async)?.status | translate }}</span
          >
        </ng-template>
      </div>
    </div>
  </div>
  <div [formGroup]="storeForm">
    <!-- Store Profile Section -->
    <app-merchant-info-bar
      [merchantName]="(storeView$ | async)?.merchantName"
      [taxId]="(storeView$ | async)?.taxId"
    ></app-merchant-info-bar>

    <div class="mb-2"></div>

    <!-- Store Profile -->
    <div class="row section-header justify-content-between">
      <span>Store Profile</span>
    </div>

    <ng-container *ngIf="isProfileTemplateReady">
      <ng-container *ngTemplateOutlet="getTemplate('storeProfile', templateVersion)"></ng-container>
    </ng-container>

    <ng-template #storeProfile1>
      <app-store-profile
        #storeProfile
        [parentForm]="storeForm"
        [mode]="data.mode"
        [page]="TDStorePage"
        [saved]="saved"
        [submitted]="submitted"
        [requestId]="data.storeId"
        [listOfChange]="listOfChange?.storeProfile"
      ></app-store-profile>
    </ng-template>
    <ng-template #storeProfile2>
      <app-store-profile-version2
        #storeProfile
        [parentForm]="storeForm"
        [mode]="data.mode"
        [page]="TDStorePage"
        [saved]="saved"
        [submitted]="submitted"
        [requestId]="data.storeId"
        [listOfChange]="listOfChange?.storeProfile"
      ></app-store-profile-version2>
    </ng-template>

    <hr class="section-divider" />
    <!-- Store Profile -->

    <!-- Store Contact -->
    <div class="row section-header justify-content-between">
      <span>Store Contact</span>
    </div>
    <app-store-contact
      #storeContact
      [parentForm]="storeForm"
      [submitted]="submitted"
      [mode]="data.mode"
      [page]="page"
      [listOfChange]="listOfChange?.storeProfile"
    ></app-store-contact>
    <hr class="section-divider" />
    <!-- Store Contact -->

    <!-- Store Location -->
    <div class="row section-header justify-content-between">
      <span>Store Location</span>
    </div>
    <app-store-location
      #storeLocation
      [parentForm]="storeForm"
      [submitted]="submitted"
      [page]="page"
      [mode]="data.mode"
      [listOfChange]="listOfChange?.storeProfile"
    ></app-store-location>
    <hr class="section-divider" />
    <!-- Store Location -->

    <!-- Store Condition -->
    <div class="row section-header">
      <span id="">Store Sale Restrictions</span>
    </div>
    <div class="sub-section-header">
      Products under the selected Store Sale Restrictions will not be ordered to this store.
    </div>
    <app-store-condition
      #storeCondition
      [parentForm]="storeForm"
      [submitted]="submitted"
      [mode]="data.mode"
      [page]="TDStorePage"
      [listOfChange]="listOfChange?.storeProfile"
    >
    </app-store-condition>

    <hr class="section-divider" />
    <!-- Store Condition -->
    <div class="row section-header">
      <span id="ORDER_POLICY" data-id="ORDER_POLICY">Order Schedule</span>
    </div>
    <app-table-order-schedule [page]="TDStorePage"></app-table-order-schedule>
  </div>

  <!--footer-->
  <ng-container *ngIf="hasAtLeastOnePermission()">
    <ng-container
      *ngIf="[storePageMode.REQUEST_CREATE, storePageMode.REQUEST_EDIT].includes(data.mode); else otherMode"
    >
      <div class="fixed-row-bottom form-row">
        <div class="float-left" *ngIf="hasSavePermission()">
          <button type="button" id="btn-save" class="btn btn-standard" (click)="onSave()">Save</button>
        </div>
        <div class="float-right" *ngIf="hasSubmitStorePermission()">
          <button type="button" id="btn-cancel" class="btn btn-standard mr-2" (click)="onCancel()">Cancel</button>
          <button type="button" id="btn-submit" class="btn btn-primary" (click)="onSubmit()">Submit</button>
        </div>
      </div>
    </ng-container>
    <ng-template #otherMode>
      <ng-container>
        <div class="fixed-row-bottom form-row">
          <div class="float-left"></div>
          <div class="float-right">
            <span *ngIf="hasEditStorePermission()" class="mr-2">
              <button type="button" id="btn-edit" class="btn btn-primary" (click)="onTriggerEdit()">Edit</button>
            </span>
            <span *ngIf="hasApproveStorePermission()">
              <button
                type="button"
                id="btn-reject"
                data-id="btn-reject"
                class="btn btn-special-reject mr-2"
                (click)="doApproveRejectRequest(false)"
              >
                Reject
              </button>
              <button
                type="button"
                id="btn-approve"
                data-id="btn-approve"
                class="btn btn-special-approve"
                (click)="doApproveRejectRequest(true)"
              >
                Approve
              </button>
            </span>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </ng-container>
  <!--End footer-->
</div>
